import { PropertyModel } from '@modules/property/property-model';

const { fields } = PropertyModel;

export default [
  fields.name,
  fields.status,
];
